import { avatarImages } from "../../data/avatarsData";
import useMenu from "../useMenu";
import Bubbles from "./Bubbles";
import useMainButtons from "./useMainButtons";

export const MainButton = (props) => {
  const { setOnClickMain, menuOptions } = useMenu(props);
  const { shadowFilter } = useMainButtons();
  const { onClickMain, setShowBlack, switchBox, openDialog, btnAvatar } = props;

  return (
    <div
      className="mainButton"
      onClick={() => {
        setOnClickMain(!onClickMain);
        setShowBlack(!onClickMain);
      }}
    >
      <div
        className="avaSelected mainButtonCircle"
        style={shadowFilter(onClickMain)}
      />
      {menuOptions
        .filter((e) => e.inner)
        .map((e, index) => (
          <Bubbles
            key={index}
            index={index}
            {...props}
            e={e}
            size={40}
            switchBox={switchBox}
            onClickMain={onClickMain}
            openDialog={openDialog}
          />
        ))}
      <img
        className="avaSelected"
        src={avatarImages["ani" + btnAvatar].svg}
        alt="avatar"
        style={{
          width: 60,
          zIndex: 1,
          transform: onClickMain ? "scale(0.9)" : "scale(1)",
        }}
      />
    </div>
  );
};
